import { render, staticRenderFns } from "./HasilPenilaianChart.vue?vue&type=template&id=5d3977a2&"
import script from "./HasilPenilaianChart.vue?vue&type=script&lang=js&"
export * from "./HasilPenilaianChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports